<template>
	<div class="section-claim">
		<div class="container">
			<div class="row">
				<div class="col-xs-12">
					<div class="claim-text text-center">
						<div class="claim-text-line-1">
							<h1>
								Ius Populi
								<div class="double-line">
									<span class="first-line">{{ $t('Section.ClaimContainerSentence1') }}<br /> </span>
									<span class="second-line">
										{{ $t('Section.ClaimContainerSentence2') }} <br />
										<router-link :to="{ name: 'about' }" :title="$t('Link.ClickForMoreInfo')">
											{{ $t('Link.ReadMore') }}
										</router-link>
									</span>
								</div>
							</h1>
						</div>
						<div class="claim-text-line-2">
							<p class="blockquote">“{{ $t('Section.ClaimContainerSentence3') }}”</p>
						</div>
						<div v-if="!isLoggedIn || (isLoggedIn && isUserAccount)" class="claim-text-line-3">
							<router-link :to="{ name: 'requestCreateStep1' }" class="button button-4">
								{{ $t('Navigation.RequestsCreate') }}
							</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import AccountInfo from '@/mixins/AccountInfo'

export default {
	name: 'ClaimContainer',
	mixins: [AccountInfo],
}
</script>



// WEBPACK FOOTER //
// src/components/sections/ClaimContainer.vue